export const locale = {
    lang: 'es',
    data: {
      'NOMBREIDIOMAS': {
        'es': 'Español',
        'en': 'Inglés',
        'pt': 'Portugués',
        'zh1': 'Chino tradicional',
        'zh2': 'Chino simplificado',
        'tr': 'Turco',
        'vi': 'Vietnamita',
        'ja': 'Japonés',
        'my': 'Malayo',
        'ru': 'Ruso',
        'ro': 'Rumano',
        'fr': 'Francés',
        'de': 'Alemán',
        'it': 'Italiano',
        'nl': 'Holandés',
        'ms': 'Malayo',
        'hi': 'Hindi',
        'id': 'Indonesio',
        'ua': 'Ucraniano',
        'ge': 'Georgiano',
        'uz': 'Uzbeko',
        'az': 'Azerí',
        'kk': 'Kazajistán',
        'hr': 'Croata',
        'ar': 'Árabe',
        'mk': 'Macedonio',
        'lv': 'Letón',
        'pr': 'Portugués (Portugal)',
        'th': 'Tailandés',
      }
    }
};
